import virtualClassroomStudentRoutes from 'modules/virtualClassrooms/common/routing/studentRoutes'

const routes = {
  root: `${virtualClassroomStudentRoutes.root}/details/event`,
}

export default routes
